import { v4 as uuidv4 } from 'uuid';

import { type Clip, ClipSource, ClipStatus, ClipType } from '@air/api/types';

export const PLACEHOLDER_CLIP_ID_PREFIX = 'placeholder-';

export const isPlaceholderClip = (clip: Pick<Clip, 'id'>): boolean => clip.id.startsWith(PLACEHOLDER_CLIP_ID_PREFIX);

export type CreatePlaceholderClipParams = {
  previewUrl: string;
  mediaUrl?: string;
  mediaType?: 'image' | 'video';
  s3Key: string;
  fileSize: number;
  width: number;
  height: number;
  workspaceId: string;
  workspaceName: string;
  workspaceImage: string;
  accountId: string;
  ownerName: string;
  ownerAvatar: string | null;
  ownerInitials: string;
};

export const createPlaceholderClip = ({
  previewUrl,
  mediaUrl,
  mediaType = 'image',
  s3Key,
  fileSize,
  width,
  height,
  workspaceId,
  workspaceName,
  workspaceImage,
  accountId,
  ownerName,
  ownerAvatar,
  ownerInitials,
}: CreatePlaceholderClipParams): Clip => {
  const id = `${PLACEHOLDER_CLIP_ID_PREFIX}${uuidv4()}`;
  const now = new Date().toISOString();
  const ext = s3Key.split('.').pop() ?? '';

  const isVideo = mediaType === 'video';

  return {
    id,
    assetId: id,
    accountId,
    workspaceId,
    workspaceName,
    workspaceImage,
    source: ClipSource.s3,
    ext,
    type: isVideo ? ClipType.video : ClipType.photo,
    size: fileSize,
    status: isVideo ? ClipStatus.transcoding : ClipStatus.transcoded,
    bookmarked: false,
    createdAt: now,
    recordedAt: now,
    updatedAt: now,
    importedName: s3Key,
    height,
    width,
    rotation: 0,
    ownerName,
    owner: {
      ownerName,
      ownerAvatar,
      ownerInitials,
    },
    avatar: null,
    assets: isVideo ? { image: previewUrl, video: mediaUrl } : { image: previewUrl },
    tags: [],
    altResolutions: [],
    smartTags: [],
    isDemo: false,
    version: 1,
    isDefault: true,
  };
};
